import { createStyles } from "@mantine/core";

export const useStyles = createStyles(() => ({
  flex: {
    flex: "1 0 auto",
  },
}));
